// extracted by mini-css-extract-plugin
module.exports = {"icon":"LoginSocial_icon__geTRZ","app":"LoginSocial_app__OIzBg","fb":"LoginSocial_fb__UmEJD","button":"LoginSocial_button__opjWK","gg":"LoginSocial_gg__uhqSj"};